import store from '@store/store.ts'
import reducer from './reducers/index.js'

store.injectReducer('timelineComments', reducer)

export { default as TimelineCommentsContainer } from './containers/TimelineCommentsContainer.js'

export default reducer
